import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class CodeScheduleDKListItem extends SearchModelBase {
    code: string = '';
    portName: string = '';
    id: number = 0;
    cy: number = 0;
    cyName: string = '';
    cfs: number = 0;
    cfsName: string = '';


    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'Code', width: 100, dataIndex: 'code'}),
        XCol.Create({ col: 1, text: 'Port Name', width: 500, dataIndex: 'portName'}),
        XCol.Create({ col: 2, text: 'CY Location', width: 500, dataIndex: 'cyName'}),
        XCol.Create({ col: 3, text: 'CFS Location', width: 500, dataIndex: 'cfsName'})
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: CodeScheduleDKListItem.prototype.code, orderByAscending: true };

    public static formatData(data: CodeScheduleDKListItem[]) {
        return data.map((d: CodeScheduleDKListItem) => ({
          ...d,
        }));
    }

}
